import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { VendorService } from '../../services/vendor-service';
import { EmployeeService } from '../../services/employee-service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password-component.html',
  styleUrls: ['./reset-password-component.css'],
 imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule
  ],
})
export class ResetPasswordComponent {
  changePwdForm: FormGroup;
  isLoading = false;
  userType: string | null = null;
  constructor(private vendorService: VendorService, private fb: FormBuilder, private snackBar: MatSnackBar, private employeeService: EmployeeService) {

    this.changePwdForm = this.fb.group({
      login: ['', Validators.required],
      old_password: ['', Validators.required],
      new_password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
      ]],
      confirmpassword: ['', Validators.required]
    }, {
      validators: this.confirmPasswordValidator('password', 'confirmpassword')
    });
  }

  ngOnInit() {
    this.userType = sessionStorage.getItem("userType");
  }

  confirmPasswordValidator(passwordControl: string, confirmPasswordControl: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get(passwordControl);
      const confirmPassword = formGroup.get(confirmPasswordControl);

      if (!password || !confirmPassword) {
        return null;
      }
      if (confirmPassword.errors && !confirmPassword.errors['mismatch']) {
        return null;
      }
      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({ mismatch: true });
        return { mismatch: true };
      } else {
        confirmPassword.setErrors(null);
        return null;
      }
    };
  }

  changePassword() {
    if (this.changePwdForm.invalid) {
      return;
    }
    if (this.isLoading) return;
    this.isLoading = true;
    const payload = {
      jsonrpc: '2.0',
      method: 'call',
      params: {
        login: this.changePwdForm.value.login,
        old_password: this.changePwdForm.value.old_password,
        new_password: this.changePwdForm.value.new_password
      }
    };
    if (this.userType == "Vendor") {
      this.vendorService.changePassword(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res && res.result.status == 200) {
            this.snackBar.open('Password changed successfully', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
          else {
            this.snackBar.open('Password change failed.', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    }
    else {
      this.employeeService.changePassword(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res && res.result.status == 200) {
            this.snackBar.open('Password changed successfully', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
          else {
            this.snackBar.open('Password change failed.', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
        }
      });
    }
  }
}
